import { render, staticRenderFns } from "./StaffHoldReservation.vue?vue&type=template&id=78d84a38&scoped=true&"
import script from "./StaffHoldReservation.vue?vue&type=script&lang=js&"
export * from "./StaffHoldReservation.vue?vue&type=script&lang=js&"
import style0 from "./StaffHoldReservation.vue?vue&type=style&index=0&id=78d84a38&prod&lang=scss&scoped=true&"
import style1 from "./StaffHoldReservation.vue?vue&type=style&index=1&id=78d84a38&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d84a38",
  null
  
)

export default component.exports